// todo refatorar quando migrar para BS5: remover jquery
export function collapse(el, shouldShow) {
    $(el).collapse(shouldShow ? 'show' : 'hide')
         .removeClass('collapsing')
}